import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DateOpenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DateOpen",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25 5.999h-3.001V5a1 1 0 1 0-2 0v.999H12V5a1 1 0 1 0-2 0v.999H7c-1.654 0-3 1.346-3 3v4a1 1 0 0 0 1 1h17.999a1 1 0 1 0 0-2H6v-3a1 1 0 0 1 1-1h3v1a1 1 0 1 0 2 0v-1h7.999v1a1 1 0 1 0 2 0v-1H25a1 1 0 0 1 1 1V25a1 1 0 0 1-1 1h-7a1 1 0 1 0 0 2h7c1.654 0 3-1.346 3-3V8.999c0-1.654-1.346-3-3-3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.25 17.5C6.355 17.5 4 19.855 4 22.75S6.355 28 9.25 28s5.25-2.355 5.25-5.25-2.355-5.25-5.25-5.25m0 8.5C7.458 26 6 24.542 6 22.75s1.458-3.25 3.25-3.25 3.25 1.458 3.25 3.25S11.042 26 9.25 26"
    })]
  }));
};
DateOpenIcon.displayName = 'DateOpenIcon';